import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Stack } from 'react-bootstrap';

const AccountManager = ({ accountManagerDetails }) => {
  const { name, phone, email, applicationNumber } = accountManagerDetails;

  return (
    <div className="px-5 py-5 fs-5">
        <h2 className="text-center fw-400"><FormattedMessage id="accountManager.header" /></h2>
        <h3 className="text-center fs-3 fw-500">{name}</h3>
        <Stack gap={2}>
        <Stack direction="horizontal">
          <FormattedMessage id="accountManager.phone" />
          <a href={`tel: ${phone}`} className="ms-auto text-decoration-none text-break text-end">{phone}</a>
        </Stack>
        <Stack direction="horizontal">
          <FormattedMessage id="accountManager.email" />
          <a href={`mailto: ${email}`} className="ms-auto text-decoration-none text-break text-end">{email}</a>
        </Stack>
        <Stack direction="horizontal">
          <FormattedMessage id="accountManager.applicationNo" />
          <span className="ms-auto">{applicationNumber}</span>
          
        </Stack>
      </Stack>
    </div>
  );
};

export default AccountManager;
